import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import LogController from "../../../controller/LogController";
import { langState } from "../../../recoil/lang";
import { ThemeState } from "../../../recoil/theme";
import { HeaderProps } from "./type";
import { masterStoreState } from "../../../recoil/auth";

let clickCount = 0;
let passwordTimer: any;

export const useHeader = (props: HeaderProps) => {
  const lang = useRecoilValue(langState);
  const master = useRecoilValue(masterStoreState);
  const theme = useRecoilValue(ThemeState);

  const [visiblePassword, setVisiblePassword] = useState<boolean>(false);
  const [visibleSelectArea, setVisibleSelectArea] = useState<boolean>(false);
  const [visibleLanguage, setVisibleLanguage] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleLogoClick = () => {
    clickCount++;
    clearTimeout(passwordTimer);
    passwordTimer = setTimeout(() => {
      clickCount = 0;
      console.log("stop?");
    }, 2000);

    if (clickCount >= 5) {
      setVisiblePassword(true);
      clearTimeout(passwordTimer);
      clickCount = 0;
    }
    console.log("click", clickCount);
  };

  // navigate
  const navigateHome = async () => {
    try {
      await LogController.click({
        path: "MainPage",
        params: "click",
        params2: "화면끄기 버튼 클릭",
      });
    } catch (err) {
      console.log(err);
    } finally {
      window.location.replace("/rest");
    }
  };
  const navigateOrderStatus = () => {
    LogController.click({
      path: "MainPage",
      params: "click",
      params2: "주문내역 버튼 클릭",
    });
    navigate(`/status`);
  };

  useEffect(() => {
    return () => {
      clearTimeout(passwordTimer);
    };
  }, []);

  useEffect(() => {
    if (
      props.deviceArea &&
      (props.deviceArea.area_number === null ||
        props.deviceArea.number === null)
    )
      setVisibleSelectArea(true);
  }, [props.deviceArea]);

  return {
    lang,
    master,
    theme,
    visiblePassword,
    visibleSelectArea,
    visibleLanguage,
    handleLogoClick,
    navigateHome,
    navigateOrderStatus,
    setVisiblePassword,
    setVisibleSelectArea,
    setVisibleLanguage,
  };
};
